const isProduction = process.env.NODE_ENV === 'production';

const SENSITIVE_PATTERNS: RegExp[] = [
  /AIza[0-9A-Za-z\-_]{35}/g, // API keys (e.g., Firebase)
  /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi // emails
];

function maskSensitive(value: any, visited = new WeakSet()): any {
  if (typeof value === 'string') {
    let masked = value;
    for (const pattern of SENSITIVE_PATTERNS) {
      masked = masked.replace(pattern, '[REDACTED]');
    }
    return masked;
  }
  if (Array.isArray(value)) {
    if (visited.has(value)) return '[Circular Reference]';
    visited.add(value);
    return value.map(item => maskSensitive(item, visited));
  }
  if (value && typeof value === 'object') {
    if (visited.has(value)) return '[Circular Reference]';
    visited.add(value);
    const result: any = {};
    for (const key of Object.keys(value)) {
      result[key] = maskSensitive(value[key], visited);
    }
    return result;
  }
  return value;
}

function sanitizeArgs(args: any[]): any[] {
  return args.map(arg => maskSensitive(arg));
}

const logger = {
  log: (...args: any[]) => {
    if (!isProduction) {
      console.log(...sanitizeArgs(args));
    }
  },
  info: (...args: any[]) => {
    if (!isProduction) {
      console.info(...sanitizeArgs(args));
    }
  },
  warn: (...args: any[]) => {
    if (!isProduction) {
      console.warn(...sanitizeArgs(args));
    }
  },
  error: (...args: any[]) => {
    if (!isProduction) {
      console.error(...sanitizeArgs(args));
    }
  }
};

export default logger;
